import React, { memo } from 'react';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { PiSmileySad } from 'react-icons/pi';

const CustomerReportsTable = memo(
  ({
    data = [],
    isLoading = false,
    error = null,
    pagination = {},
    setSearchParams,
    page = 1,
    limit = 10,
  }) => {
    const handleChangePage = (event, newPage) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('page', String(newPage + 1));
        return next;
      });
    };

    const handleChangeRowsPerPage = (event) => {
      const newLimit = parseInt(event?.target?.value, 10) || 10;
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('limit', String(newLimit));
        next.set('page', '1');
        return next;
      });
    };

    const columns = [
      { id: 'name', label: 'Name', minWidth: 150 },
      { id: 'phone', label: 'Phone', minWidth: 120 },
      {
        id: 'total_buys',
        label: 'Total Buys',
        minWidth: 120,
        format: (value) => value?.toLocaleString(),
      },
    ];

    const totalCount = pagination?.totalRecords ?? 0;

    if (isLoading) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.loadingWrap}>
            <Loading variant="inline" label="" />
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.noData}>
            <PiSmileySad className={styles.noDataIcon} aria-hidden />
            <p>Error loading data: {error}</p>
          </div>
        </div>
      );
    }

    if (!data.length) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.noData}>
            <PiSmileySad className={styles.noDataIcon} aria-hidden />
            <p>No customer reports data available.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.wrapper}>
        <Table
          columns={columns}
          rows={data}
          page={page - 1}
          rowsPerPage={limit}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalCount={totalCount}
          disableInternalPagination
        />
      </div>
    );
  }
);

export default CustomerReportsTable;
